/** @flow */

import moment from 'moment';
import { LinkableCampaign, type ExternalCampaignListing } from 'statsradio/modules/campaigns/domain/CampaignV2Listing';

export type CampaignDashboardListingData = {
  reference: string;
  name: string;
  startAt: string;
  externalCampaigns: ExternalCampaignListing[];
}

export default class CampaignDashboardListing implements LinkableCampaign {
  reference: string;
  name: string;
  startAt: moment;
  externalCampaigns: ExternalCampaignListing[];

  constructor(reference: string, name: string, startAt: moment, externalCampaigns: ExternalCampaignListing[]) {
    this.reference = reference;
    this.name = name;
    this.startAt = startAt;
    this.externalCampaigns = externalCampaigns;
  }

  isStartedSince(days: number) {
    return this.startAt.diff(moment(), 'days') <= days;
  }

  isLinked(): boolean {
    return this.externalCampaigns.length > 0;
  }

  getReference(): string {
    return this.reference;
  }

  getLinkedExternalCampaigns(): ExternalCampaignListing[] {
    return this.externalCampaigns;
  }

  static parse(data: CampaignDashboardListingData) {
    return new CampaignDashboardListing(
      data.reference,
      data.name,
      moment(data.startAt),
      data.externalCampaigns,
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modules/campaign/domain/CampaignDashboardListing.js